export default{
    calculation(index,amount,unitPrice,supplyPrice,tax){
        var calculationUnitPrice = document.getElementById(unitPrice+index).value.replace(/,/g,"")
        var calculationAmount = document.getElementById(amount+index).value.replace(/,/g,"")
        if(!isNaN(calculationUnitPrice) && !isNaN(calculationAmount)){
            document.getElementById(supplyPrice+index).value = calculationUnitPrice * calculationAmount

            document.getElementById(tax+index).value = (document.getElementById(supplyPrice+index).value.replace(/,/g,"") * 0.1).toFixed()

            document.getElementById(supplyPrice+index).dispatchEvent(new Event('input'));
            document.getElementById(tax+index).dispatchEvent(new Event('input'));

        }
    },
    total(index,totalPrice,SupplyPrice,Tax){
        var totalSupplyPrice = 0
        var totalTax = 0
        var total = 0
        for(var i=0; i<index; i++){
            if(parseInt(document.getElementById('unitPrice'+i).value)!=0 && !isNaN(parseInt(document.getElementById('supplyPrice'+i).value.replace(/,/g,"")))){
                totalSupplyPrice += parseInt(document.getElementById('supplyPrice'+i).value.replace(/,/g,""))
                totalTax += parseInt(document.getElementById('tax'+i).value.replace(/,/g,""))
                total += parseInt(document.getElementById('supplyPrice'+i).value.replace(/,/g,"")) + parseInt(document.getElementById('tax'+i).value.replace(/,/g,""))
            }
        }
        document.getElementById(SupplyPrice).value=totalSupplyPrice
        document.getElementById(Tax).value=totalTax
        document.getElementById(totalPrice).value=total

        document.getElementById(SupplyPrice).dispatchEvent(new Event('input'))
        document.getElementById(Tax).dispatchEvent(new Event('input'))
        document.getElementById(totalPrice).dispatchEvent(new Event('input')) 

    }
}

